// Avatar options for wish cards
// Using inline SVG paths for universal device compatibility (no emoji rendering issues)

export const AVATARS = [
  {
    id: 'lotus',
    label: 'ดอกบัว',
    gradient: 'from-pink-500/20 to-purple-500/20',
    border: 'border-pink-400/30',
    // Lotus flower SVG
    svg: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6C20 6 14 12 14 18C14 22 16.5 24.5 20 25.5C23.5 24.5 26 22 26 18C26 12 20 6 20 6Z" fill="#e88bc7" opacity="0.9"/>
      <path d="M20 25.5C16 25.5 11 21 9.5 16C8 21 9.5 27 14 30C16.5 31.5 18.5 31.5 20 32C21.5 31.5 23.5 31.5 26 30C30.5 27 32 21 30.5 16C29 21 24 25.5 20 25.5Z" fill="#c850c0" opacity="0.6"/>
      <path d="M20 32C17 32 13 29 11 25.5C10 29 12 33 16 35C18 36 19 36 20 36.5C21 36 22 36 24 35C28 33 30 29 29 25.5C27 29 23 32 20 32Z" fill="#7b2ff2" opacity="0.35"/>
    </svg>`,
  },
  {
    id: 'butterfly',
    label: 'ผีเสื้อ',
    gradient: 'from-cyan-500/20 to-blue-500/20',
    border: 'border-cyan-400/30',
    // Butterfly SVG
    svg: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 14C16 10 10 8 8 12C6 16 10 20 14 20C10 20 6 24 8 28C10 32 16 30 20 26" fill="#4fd1ff" opacity="0.8"/>
      <path d="M20 14C24 10 30 8 32 12C34 16 30 20 26 20C30 20 34 24 32 28C30 32 24 30 20 26" fill="#7eb8e0" opacity="0.7"/>
      <ellipse cx="20" cy="20" rx="1.5" ry="7" fill="#4fd1ff" opacity="0.9"/>
      <circle cx="15" cy="14" r="2" fill="#fff" opacity="0.3"/>
      <circle cx="25" cy="14" r="2" fill="#fff" opacity="0.3"/>
    </svg>`,
  },
  {
    id: 'crystal',
    label: 'คริสตัล',
    gradient: 'from-blue-500/20 to-indigo-500/20',
    border: 'border-blue-400/30',
    // Crystal/gem SVG
    svg: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6L28 16L20 34L12 16L20 6Z" fill="#7b2ff2" opacity="0.7"/>
      <path d="M20 6L28 16L20 18L12 16L20 6Z" fill="#4fd1ff" opacity="0.6"/>
      <path d="M20 18L28 16L20 34Z" fill="#c850c0" opacity="0.4"/>
      <path d="M12 16L20 18L20 34Z" fill="#7b2ff2" opacity="0.5"/>
      <path d="M20 6L24 11L20 13L16 11Z" fill="#fff" opacity="0.2"/>
    </svg>`,
  },
  {
    id: 'moon',
    label: 'พระจันทร์',
    gradient: 'from-indigo-500/20 to-purple-500/20',
    border: 'border-indigo-400/30',
    // Crescent moon with star SVG
    svg: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 8C18 8 13 13 13 20C13 27 18 32 24 32C20 30 17 25.5 17 20C17 14.5 20 10 24 8Z" fill="#c8d4e8" opacity="0.8"/>
      <path d="M28 10L29 13L32 13L29.5 15L30.5 18L28 16L25.5 18L26.5 15L24 13L27 13Z" fill="#e88bc7" opacity="0.7"/>
      <circle cx="30" cy="24" r="1" fill="#4fd1ff" opacity="0.5"/>
      <circle cx="26" cy="28" r="0.8" fill="#7b2ff2" opacity="0.4"/>
    </svg>`,
  },
  {
    id: 'star',
    label: 'ดาว',
    gradient: 'from-purple-500/20 to-pink-500/20',
    border: 'border-purple-400/30',
    // Star/sparkle SVG
    svg: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6L22.5 16L32 16L24.5 22L27 32L20 26L13 32L15.5 22L8 16L17.5 16Z" fill="#e88bc7" opacity="0.8"/>
      <path d="M20 6L22.5 16L32 16L24.5 22L27 32L20 26L13 32L15.5 22L8 16L17.5 16Z" fill="#7b2ff2" opacity="0.3"/>
      <path d="M20 10L21.5 16L27 16L22.5 20L24 26L20 22.5L16 26L17.5 20L13 16L18.5 16Z" fill="#fff" opacity="0.15"/>
    </svg>`,
  },
]

export function getAvatarById(id) {
  return AVATARS.find(a => a.id === id) || AVATARS[0]
}
